// Material UI
import { makeStyles } from '@material-ui/core'
import Colors from '../../constants/Colors'
export default makeStyles(theme => ({
  dateFilterTitle: {
    color: Colors.PRIMARY_FONT_COLOR,
    fontFamily: 'Poppins',
    fontSize: 17,
    fontWeight: 'normal',
    lineHeight: 'normal',
    marginBottom: 24,
    marginTop: 0,
  },
  dateSelectorRoot: {
    borderTop: `1px solid ${Colors.DISABLED_COLOR}`,
    display: 'flex',
    flexDirection: 'column',
    padding: '24px',
  },
}))
